/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Preview_TitleInputs */

const en_wc_on_preview_title = /** @type {(inputs: Wc_On_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or try it right here`)
};

/**
* | output |
* | --- |
* | "Or try it right here" |
*
* @param {Wc_On_Preview_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_preview_title = /** @type {((inputs?: Wc_On_Preview_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Preview_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_preview_title(inputs)
});
export { wc_on_preview_title as "wc.on.preview_title" }